import {
  CoreApi,
  Product,
  IgnoreHighlightComponent,
  ProductDesign,
  IncludedShelfComponent
} from '@inter-ikea-storageone/range';
import { CornerSolutionShelfReplacementComponent } from '@inter-ikea-storageone/range-pax';
import { Entity } from '@inter-ikea-core/core';
import { getReplaceableProduct } from './utils';

export const changeInteriorColor = (
  coreApi: CoreApi,
  interiors: Entity[],
  design: ProductDesign,
  products: Product[]
): boolean => {
  let notReplaceableInteriorFound = false;
  interiors.forEach(interior => {
    const newInterior = getReplaceableProduct(interior, design, products);
    if (newInterior) {
      const replacesIncludedShelfInCornerFrame =
        interior.hasComponent(IncludedShelfComponent.id) ||
        interior.hasComponent(CornerSolutionShelfReplacementComponent.id);
      const replacePlacementResult = coreApi.products.replace(
        interior.id,
        newInterior.coreProductId,
        true
      );
      const newEntity = replacePlacementResult?.replacedEntityResult.placedEntity;

      // Get all invalid children
      const invalidChildrenAfterReplace = replacePlacementResult?.childrenResult.filter(
        c => !c.valid
      );

      // Remove invalid children after replace
      invalidChildrenAfterReplace?.map(
        c => c.placedEntity && coreApi.entities.delete(c.placedEntity)
      );

      if (newEntity) {
        newEntity.addComponent(new IgnoreHighlightComponent());
        if (replacesIncludedShelfInCornerFrame) {
          newEntity.addComponent(new CornerSolutionShelfReplacementComponent());
        }
      }
    } else {
      notReplaceableInteriorFound = true;
    }
  });
  return notReplaceableInteriorFound;
};
